const initialState = {
  index: [],
  data: {},
};

const HistoryPoints = (state = initialState, action) => {
  switch (action.type) {
    case "CONTENT_HISTORY_POINTS_INDEX":
      return { ...state, index: action.payload.index };
    case "CONTENT_HISTORY_POINTS_DATA":
      return { ...state, data: action.payload.data };
    case "CONTENT_HISTORY_POINTS_RESET":
      return initialState;
    default:
      return state;
  }
};

export default HistoryPoints;
